<template>
  <van-collapse v-model="activeNames">
    <van-collapse-item class="r-1" title="基础信息" name="1">
      <van-cell-group><van-field label="案号" :value="data.caseNo" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="开庭时间" :value="data.courtTime" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="地区" :value="data.province" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="排期日期" :value="data.scheduleTime" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="承办部门" :value="data.undertakeDep" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="审判长/主审人" :value="data.justiceChief" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="法院" :value="data.court" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="公告内容" :value="data.content" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="案由" :value="data.caseReason" placeholder="无" readonly /></van-cell-group>
    </van-collapse-item>
    <van-collapse-item title="当事人信息" name="2">
      <div
        class="item coll2 comWrapper card mt-2 mb-2 p-3"
        v-for="(item, index) in data.partyList"
        :key="index"
      >
        <div class="comWrapper-wrapper van-hairline--bottom">
          <span></span>
          {{ item[partyListCol[0].field] }}
        </div>
        <van-cell-group>
          <template v-for="(col, idx) in partyListCol">
            <van-cell
              v-if="idx > 0"
              :key="'col_' + idx"
              :title="col.title"
              :value="item[col.field]"
            />
          </template>
        </van-cell-group>
      </div>
    </van-collapse-item>
  </van-collapse>
</template>

<script>
import detailMixin from "../mixins/detail-mixin"
export default {
  name: "courtAnnoCheckDetail",
  mixins: [detailMixin],
  data() {
    return {
      activeNames: ["1", "2"],
      partyListCol: [
        { title: "序号", field: "sort" },
        { title: "案件角色", field: "roleType" },
        { title: "当事人名称", field: "name"}
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";
@import "../style.scss";
.r-1 /deep/ .van-collapse-item__content {
  padding: 0px 16px;
}
.coll2 .van-cell__value {
  flex: 1;
  margin-left: 8px;
}
.coll2 .van-cell {
  padding: 10px 0;

  &::after{
    left: 0;
  }
}

.coll3 /deep/ .van-field__label {
  flex: 1;
}
</style>